import { render, staticRenderFns } from "./CreateLeadItemSidebar.vue?vue&type=template&id=a005585e&"
import script from "./CreateLeadItemSidebar.vue?vue&type=script&lang=js&"
export * from "./CreateLeadItemSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports